/**
 * @module @nhtio/eslint-config/blocks/vue
 */

import * as espree from 'espree'
import { default as tseslint } from 'typescript-eslint'
import { RULES_LIST } from '../libs/adonisjs_eslint_config'
import { default as vueEslintParser } from 'vue-eslint-parser'
import type { FlatConfig } from '@typescript-eslint/utils/ts-eslint'

/**
 * An ESLint Configuration for Vue + TypeScript files with the .vue extension
 */
const vue: FlatConfig.Config = {
  name: 'NHT Vue',
  languageOptions: {
    parser: vueEslintParser,
    parserOptions: {
      parser: {
        'js': espree,
        'ts': tseslint.parser,
        '<template>': espree,
      },
      sourceType: 'module',
      warnOnUnsupportedTypeScriptVersion: false,
      extraFileExtensions: ['.vue'],
      projectService: {
        allowDefaultProject: ['*.vue', '*.ts', '*.mts', '*.js', '*.mjs'],
      },
    },
  },
  rules: {
    ...RULES_LIST,
    'no-unused-vars': ['error', { varsIgnorePattern: '^_', argsIgnorePattern: '^_' }],
    'vue/max-attributes-per-line': [
      'error',
      {
        singleline: {
          max: 8,
        },
        multiline: {
          max: 1,
        },
      },
    ],
    'prettier/prettier': ['error', { endOfLine: 'auto' }],
    '@nht/vueprint-type-import-only': 'error',
    '@nht/no-window-negation': 'error',
    'vue/singleline-html-element-content-newline': 'off',
    'vue/html-self-closing': 'off',
  },
  files: ['**/*.vue'],
}

export default vue
